import React, { useState } from 'react'

const TabWithBottomBorder = ({newDesign,getTabContent, tabs, activeTab, setActiveTab,setValue}) => {
   
  return (
    <div className={`mytabs-container ${newDesign ?'mt-3 tab-backgrounnd-new-style':''}`}>
    <div className={`mytabs ${newDesign ? 'mytab-v2':''}`}>
        {
            tabs.map((tab, index) => {
                return (
                    <button
                    // className={activeTab === index ? 'mytab tab-active' : 'mytab'}
                    className={`mytab ${activeTab === index ? 'tab-active' : ''} ${newDesign?'mytab-v2' :''}`}
                    onClick={() => {
                      if (setValue)
                        setValue(0)
                        setActiveTab(index)}}
                  >
                    {tab}
                  </button>
                )
            })
        }
     
      {/* <button
        className={activeTab === 'tournaments' ? 'mytab active' : 'mytab'}
        onClick={() => setActiveTab('tournaments')}
      >
        tournaments
      </button>
      <button
        className={activeTab === 'private' ? 'mytab active' : 'mytab'}
        onClick={() => setActiveTab('private')}
      >
        private
      </button> */}
    </div>
    <div className="mytab-content-container">{getTabContent()}</div>
  </div>
  )
}

export default TabWithBottomBorder